import { render, staticRenderFns } from "./TemposTk.vue?vue&type=template&id=dd60cc32"
import script from "./TemposTk.vue?vue&type=script&lang=js"
export * from "./TemposTk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports